import React from 'react';

import { Col, Row, Skeleton } from 'antd';

import WorkOrderOpen from '../DashboardEstimatorView/WorkOrderOpen';
import WorkOrderAuthorized from '../DashboardEstimatorView/WorkOrderAuthorized';
import WorkOrderClosed from '../DashboardEstimatorView/WorkOrderClosed';
import WorkOrderCanceled from '../DashboardEstimatorView/WorkOrderCanceled';
import PartsAndServicesChart from '../Mock/MockCharts/PartsAndServicesChart';
import { DashboardType } from '@/core/domain/workorder/Dashboard/Dashboard.types';
import HomeInformatives from '../Mock/HomeInformatives';
import { useDashboardData } from '@/core/domain/workorder/Dashboard/Dashboard.hooks';
import VehicleEntryAndExit from './VehicleEntryAndExit';

const DashboardEstimatorView: React.FC = () => {
  const { data, isLoading } = useDashboardData({
    dashboardType: DashboardType.workOrder,
  });

  return (
    <Skeleton active loading={isLoading} paragraph={{ rows: 10 }}>
      <Row gutter={[16, 16]}>
        <Col span={24} sm={12} md={12} lg={12} xl={6}>
          <WorkOrderOpen
            workOrderValueOpenMonth={data?.workOrderOpenMonth}
            workOrderValueTotal={data?.workOrderOpenTotal}
          />
        </Col>

        <Col span={24} sm={12} md={12} lg={12} xl={6}>
          <WorkOrderAuthorized
            workOrderValueAuthorizedMonth={data?.workOrderAuthorizedMonth}
            workOrderValueTotal={data?.workOrderAuthorizedTotal}
          />
        </Col>

        <Col span={24} sm={12} md={12} lg={12} xl={6}>
          <WorkOrderCanceled
            workOrderValueCanceledMonth={data?.workOrderCancelledMonth}
            workOrderValueTotal={data?.workOrderCancelledTotal}
          />
        </Col>

        <Col span={24} sm={12} md={12} lg={12} xl={6}>
          <WorkOrderClosed
            workOrderValueClosedMonth={data?.workOrderClosedMonth}
            workOrderValueTotal={data?.workOrderClosedTotal}
          />
        </Col>

        <Col span={24} lg={12}>
          <PartsAndServicesChart style={{ height: '450px' }} />
        </Col>

        <Col span={24} lg={12}>
          <Row gutter={[16, 16]}>
            <VehicleEntryAndExit
              vehiclesEntryMonth={data?.vehiclesEntryMonth || 0}
              vehiclesReturnMonth={data?.vehiclesReturnMonth || 0}
            />

            <Col span={24}>
              <HomeInformatives />
            </Col>
          </Row>
        </Col>
      </Row>
    </Skeleton>
  );
};

export default DashboardEstimatorView;
